import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from 'seagull';
import { routes } from "../../../../constants";
import { formatNumericUSDate } from "../../../../utils";
const ViewInvoice = _ref => {
  let {
    relationshipID,
    date,
    testid
  } = _ref;
  return /*#__PURE__*/React.createElement(Typography, {
    as: Link,
    to: "".concat(routes.billingHub(relationshipID), "?selectedDate=").concat(formatNumericUSDate(date)),
    "data-testid": testid,
    variant: "paragraph1",
    noWrap: true,
    ellipsis: true
  }, "View Invoice");
};
export default ViewInvoice;